module.exports = __webpack_public_path__ + "static/media/portfolio_suyog.94096f98.jpg";